import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-modal';
import Select from 'react-select';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";

function CreateManifest() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [isInput, setInput] = useState("SELF");
    const [getTransport, setGetTransport] = useState([]);
    const [getVehicle, setGetVehicle] = useState([]);
    const [getDriver, setGetDriver] = useState([]);
    const [getVendor, setGetVendor] = useState([]);
    const [getCity, setGetCity] = useState([]);
    const [getBranch, setGetBranch] = useState([]);
    const [getMode, setGetMode] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [getManifest, setGetManifest] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDocketNos, setSelectedDocketNos] = useState([]);
    const [selectedManifestRows, setSelectedManifestRows] = useState([]);
    const [getFlight, setGetFlight] = useState([]);
    const [getTrain, setGetTrain] = useState([]);
    const [fromDate, setFromDate] = useState(firstDayOfMonth);
    const [toDate, setToDate] = useState(today);
    const [formData, setFormData] = useState({
        maniDate: new Date(),
        fromDest: JSON.parse(localStorage.getItem("Login"))?.Branch_Code || "",
        toDest: '',
        mode: '',
        transportType: '',
        vehicleType: '',
        vehicleNo: '',
        driverName: '',
        driverMobile: '',
        vendorCode: '',
        vendorAwbNo: '',
        MAwbNo: '',
        bagNo: '',
        DoxSpx: '',
        remark: '',
        bookingWeight: '',
        manifestWeight: '',
        Train_Code: '',
        TrainNo: '',
        Flight_Code: '',
        FlightNo: '',
        docketNo: []
    });


    const [isChecked, setIsChecked] = useState(
        {
            Vehicle_Detail: false,
            Vehicle_Type: false,
            Driver_Name: false,
            Train_Name: false,
            Flight_Name: false,
            Vendor_Name: false,
            Vendor_Awb_No: false,
            Remark: false,
            Manifest_Weight: false,
            MasterAwbNo: false,
            Dox_Spx: false,
            BagNo: false,
        })
    const [isAllChecked, setIsAllChecked] = useState(false);
    const handleDateChange = (date, field) => {
        setFormData({ ...formData, [field]: date });
    };

    const loginBranchCode = JSON.parse(localStorage.getItem("Login"))?.Branch_Code;
    const branchOptions =

        [

            ...getBranch.map(city => ({
                value: city.Branch_Code,   // adjust keys from your API
                label: city.Branch_Name,
            }))
        ]




    const handleCheckChange = (e) => {
        const { name, checked } = e.target;

        // If ALL checkbox is toggled
        if (name === "all") {
            setIsAllChecked(checked); // update main checkbox

            const updated = Object.fromEntries(
                Object.keys(isChecked).map(k => [k, checked])
            );

            setIsChecked(updated);
            return;
        }

        // Individual Checkbox
        setIsChecked(prev => {
            const updated = { ...prev, [name]: checked };

            // If all single checkboxes are true -> selectAll = true
            const allSelected = Object.values(updated).every(v => v === true);
            setIsAllChecked(allSelected);

            return updated;
        });
    };


    const fetchDataM = async () => {
        setLoading(true);
        try {
            const login = JSON.parse(localStorage.getItem("Login"));
            const formatDate = (date) => {
                const d = new Date(date);
                return d.toISOString().split("T")[0]; // ✅ SAFE
            };

            const response = await getApi(
                `/Manifest/getPendingManifest?DocketNo=${searchQuery}&branchCode=${login?.Branch_Code}&pageNumber=${currentPage}&pageSize=${rowsPerPage}&FromDate=${formatDate(fromDate)}&ToDate=${formatDate(toDate)}`
            );

            const currentPageData = response?.Data || [];

            setGetManifest(currentPageData);

            // ✅ USE BACKEND COUNT
            setTotalRecords(response?.totalCount || 0);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDataM();
    }, [currentPage, rowsPerPage, fromDate, toDate, searchQuery]);


    const convertDateFormat = (dateStr) => {
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };




    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const fetchData = async (endpoint, setData) => {


        try {
            const response = await getApi(endpoint);
            const data = response.Data || response.data
            // Check if the response contains data, then update the corresponding state
            if (data) {
                setData(Array.isArray(data) ? data : []);
            } else {
                setData([]);
            }
        } catch (err) {
            console.error(`Error fetching data from ${endpoint}:`, err);
            setError(err);
        }
    };

    const fetchBranchData = async () => {
        try {
            const response = await getApi(`/Master/GetAllBranchData?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`);
            setGetBranch(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
            setError(err);
        }
    };

    useEffect(() => {

        const fetchSetup = async () => {
            try {
                const response = await getApi(`/Master/getManifestSetup`);

                if (response.status === 1) {
                    const setup = response.data[0];

                    const updatedChecks = {
                        Vehicle_Detail: setup.Vehicle_Detail,
                        Vehicle_Type: setup.Vehicle_Type,
                        Driver_Name: setup.Driver_Name,
                        Train_Name: setup.Train_Name,
                        Flight_Name: setup.Flight_Name,
                        Vendor_Name: setup.Vendor_Name,
                        Vendor_Awb_No: setup.Vendor_Awb_No,
                        Remark: setup.Remark,
                        Manifest_Weight: setup.Manifest_Weight,
                        MasterAwbNo: setup.MasterAwbNo,
                        Dox_Spx: setup.Dox_Spx,
                        BagNo: setup.BagNo,
                    };

                    // set all checkbox state
                    setIsChecked(updatedChecks);

                    // auto enable Select All if all values true
                    const allSelected = Object.values(updatedChecks).every(v => v === true);
                    setIsAllChecked(allSelected);
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchSetup();


        fetchBranchData();
        fetchData('/Master/getMode', setGetMode);
        fetchData('/Master/getVendor', setGetVendor);
        fetchData('/Master/getGetdriver', setGetDriver);
        fetchData('/Master/VehicleMaster', setGetVehicle);
        fetchData('/Master/gettransport', setGetTransport);
        fetchData('/Master/GetAllFlights', setGetFlight);
        fetchData('/Master/GetAllTrains', setGetTrain);

    }, []);
    useEffect(() => {
        const fetchData = async (setData, Product_Type) => {


            try {
                const response = await getApi(`/Master/GetInterDomestic?Product_Type=${Product_Type}`);
                const data = response.Data || response.data
                // Check if the response contains data, then update the corresponding state
                if (data) {
                    setData(Array.isArray(data) ? data : []);
                } else {
                    setData([]);
                }
            } catch (err) {
                console.error(`Error fetching data from /Master/GetInterDomestic:`, err);

            }

        };
        const Product_Type = getMode.find(m => m.Mode_Code === formData.mode)?.Mode_Type == "INTERNATIONAL" ? "International" : "Domestic"
        fetchData(setGetCity, Product_Type);
    }, [formData.mode])


    const handleSelectAll = () => {
        const newState = !selectAll;
        setSelectAll(newState);

        if (newState) {
            // Select All
            setSelectedRows(getManifest.map((_, index) => index));                    // row index array
            setSelectedDocketNos(getManifest.map(m => m.DocketNo));                   // all docket numbers
            setSelectedManifestRows([...getManifest]);                                // entire row data
        } else {
            // Unselect All
            setSelectedRows([]);
            setSelectedDocketNos([]);
            setSelectedManifestRows([]);
        }
    };



    const handleRowSelect = (index, docketNo, n) => {
        const already = selectedRows.includes(index);
        const updatedRows = already ? selectedRows.filter(i => i !== index) : [...selectedRows, index];
        if (already) {
            setSelectedDocketNos(selectedDocketNos.filter(docket => docket !== docketNo));
            setSelectedManifestRows(selectedManifestRows.filter(row => row.DocketNo !== docketNo));
        } else {
            setSelectedDocketNos([...selectedDocketNos, docketNo]);
            setSelectedManifestRows([
                ...selectedManifestRows,
                getManifest.find(manifest => manifest.DocketNo === docketNo)
            ]);
        }
        setSelectedRows(updatedRows);
        setSelectAll(updatedRows.length === n);
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleDocketNoSelect = () => {
        setFormData((prevData) => ({
            ...prevData,
            docketNo: selectedDocketNos,
        }));
        setModalIsOpen(false);
    };
    const handleFind = () => {
        // scanner may send Enter/new line/spaces
        const doc = String(formData.bookingWeight)
            .trim()
            .replace(/\r|\n/g, "");

        if (!doc) {
            Swal.fire({
                icon: "warning",
                title: "Empty",
                text: "Enter docket number!"
            });
            return;
        }

        const found = getManifest.find(
            m => String(m.DocketNo).trim() === doc
        );

        if (!found) {
            Swal.fire({
                icon: "error",
                title: "Not Found!",
                text: `Docket No ${doc} not exists in Manifest List`
            });
            setFormData(prev => ({
                ...prev,
                bookingWeight: ""
            }));
            return;
        }

        if (selectedDocketNos.includes(doc)) {
            Swal.fire({
                icon: "warning",
                title: "Already Selected",
                text: `Docket No ${doc} already added`
            });
            setFormData(prev => ({
                ...prev,
                bookingWeight: ""
            }));


            return;
        }

        setSelectedDocketNos(prev => [...prev, doc]);
        setSelectedManifestRows(prev => [...prev, found]);

        const index = getManifest.findIndex(
            m => String(m.DocketNo).trim() === doc
        );

        setSelectedRows(prev => [...prev, index]);

        setSelectAll(
            selectedDocketNos.length + 1 === getManifest.length
        );

        // clear after scan
        setFormData(prev => ({
            ...prev,
            bookingWeight: ""
        }));
    };

    const formatDate = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}/${month}/${year}`;
    };

    const allFlightOptions = getFlight.map(f => ({
        value: f.Flight_Code,   // what you store
        label: f.Flight_Name, // visible in dropdown
        flightNo: f.Flight_No,  // extra info if needed
    }));

    const allTrainOptions = getTrain.map(t => ({
        value: t.Train_Code,   // what you store
        label: t.Train_Name, // visible in dropdown
        trainNo: t.Train_No,  // extra info if needed
    }));

    const handleReset = () => {
        // 🔁 Reset Form after success
        setFormData({
            maniDate: new Date(),
            fromDest: JSON.parse(localStorage.getItem("Login"))?.Branch_Code || "",
            toDest: "",
            mode: "",
            transportType: "",
            vehicleType: "",
            vehicleNo: "",
            driverName: "",
            driverMobile: "",
            vendorCode: "",
            vendorAwbNo: "",
            MAwbNo: "",
            bagNo: "",
            DoxSpx: "",
            remark: "",
            Train_Code: "",
            TrainNo: "",
            Flight_Code: "",
            FlightNo: "",
            docketNo: []
        });

        setSelectedManifestRows([]);
        setSelectedRows([]);
        setSelectedDocketNos([]);
        setSelectAll(false);
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.toDest) {
            Swal.fire({
                icon: "warning",
                title: "To City is required",
                text: "Please select at least one Docket before submit!"
            });
            return;
        }

        if (selectedDocketNos.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Dockets Selected",
                text: "Please select at least one Docket before submit!"
            });
            return;
        }

        // 🔥 Complete final payload matching Node API
        const requestPayload = {
            DocketNo: selectedDocketNos,
            sessionLocationCode: formData.fromDest,
            toDest: formData.toDest,
            Mode: formData.mode,
            Remark: formData.remark,
            transporterType: formData.transportType,
            Vehicletype: formData.vehicleType,
            VehicleNo: formData.vehicleNo,
            VendorCode: formData.vendorCode,
            VendorAwbNo: formData.vendorAwbNo,
            driverName: formData.driverName,
            driverMobile: String(formData.driverMobile),
            ManifestDate: formatDate(formData.maniDate),
            DispatchFlag: "1",
            // 🔥 New Added Keys
            Train_Code: formData.Train_Code || null,
            Flight_Code: formData.Flight_Code || null,
            MasterAwbNo: formData.MAwbNo || null,
            DoxSpx: formData.DoxSpx || null,
        };

        try {
            const response = await postApi("/Manifest/generateManifest", requestPayload);
            if (response.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Manifest Generated",
                    text: response?.message || "Data Generated Successfully",
                    showConfirmButton: true
                });

                // 🔁 Reset Form after success
                setFormData({
                    maniDate: new Date(),
                    fromDest: JSON.parse(localStorage.getItem("Login"))?.Branch_Code || "",
                    toDest: "",
                    mode: "",
                    transportType: "",
                    vehicleType: "",
                    vehicleNo: "",
                    driverName: "",
                    driverMobile: "",
                    vendorCode: "",
                    vendorAwbNo: "",
                    MAwbNo: "",
                    bagNo: "",
                    DoxSpx: "",
                    remark: "",
                    Train_Code: "",
                    TrainNo: "",
                    Flight_Code: "",
                    FlightNo: "",
                    docketNo: []
                });

                await fetchDataM()
                setSelectedManifestRows([]);
                setSelectedRows([]);
                setSelectedDocketNos([]);
                setSelectAll(false);
            }



        } catch (error) {
            console.error("Error:", error);
            Swal.fire({ icon: "error", title: "Failed", text: error?.message || "Try again later." });
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        const requestPayload = {
            Manifest_ID: 1,
            Vehicle_Detail: isChecked.Vehicle_Detail,
            Vehicle_Type: isChecked.Vehicle_Type,
            Driver_Name: isChecked.Driver_Name,
            Train_Name: isChecked.Train_Name,
            Flight_Name: isChecked.Flight_Name,
            Vendor_Name: isChecked.Vendor_Name,
            Vendor_Awb_No: isChecked.Vendor_Awb_No,
            Remark: isChecked.Remark,
            Manifest_Weight: isChecked.Manifest_Weight,
            MasterAwbNo: isChecked.MasterAwbNo,
            Dox_Spx: isChecked.Dox_Spx,
            BagNo: isChecked.BagNo,
        };
        try {
            const response = await postApi('/Master/updateManifestSetup', requestPayload);
            setModalIsOpen2(false);
        } catch (error) {
            console.error("Error submitting manifest: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while generating data. Please try again.',
            });
        }
    };



    return (
        <>
            <div className="body">
                <div className="container1" >

                    <form onSubmit={handleSubmit}>
                        <div className="fields2">
                            <div className="input-field3" >
                                <label htmlFor="">Manifest Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.maniDate}
                                    onChange={(date) => handleDateChange(date, "maniDate")}
                                    dateFormat="dd/MM/yyyy"

                                />

                            </div>


                            <div className="input-field3" >
                                <label htmlFor="">To City</label>
                                <Select
                                    options={getCity.map(city => ({
                                        value: city.City_Code,   // adjust keys from your API
                                        label: city.City_Name
                                    }))}
                                    value={
                                        formData.toDest
                                            ? { value: formData.toDest, label: getCity.find(c => c.City_Code === formData.toDest)?.City_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            toDest: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Select City"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                />

                            </div>

                            <div className="input-field3" >
                                <label htmlFor="">Mode</label>
                                <Select
                                    options={getMode.map(mode => ({
                                        value: mode.Mode_Code,   // adjust keys from your API
                                        label: mode.Mode_Name
                                    }))}
                                    value={
                                        formData.mode
                                            ? { value: formData.mode, label: getMode.find(c => c.Mode_Code === formData.mode)?.Mode_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            mode: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Select Mode"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                />

                            </div>


                            {isChecked.Vehicle_Detail &&
                                <div className="input-field3" >
                                    <label htmlFor="">Vehicle Detail</label>
                                    <Select
                                        options={getTransport.map(tra => ({
                                            value: tra.Transport_Code,   // adjust keys from your API
                                            label: tra.Transport_Name
                                        }))}
                                        value={
                                            formData.transportType
                                                ? { value: formData.transportType, label: getTransport.find(c => c.Transport_Code === formData.transportType)?.Transport_Name || "" }
                                                : null
                                        }
                                        onChange={(selectedOption) => {
                                            setFormData({
                                                ...formData,
                                                transportType: selectedOption ? selectedOption.value : ""
                                            });
                                            setInput(selectedOption.label.trim());
                                        }}
                                        placeholder="Vehicle Details"
                                        isSearchable
                                        classNamePrefix="blue-selectbooking"
                                        className="blue-selectbooking"
                                        menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                        styles={{
                                            placeholder: (base) => ({
                                                ...base,
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }),
                                            menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                        }}
                                    />
                                </div>}

                            {isChecked.Vehicle_Type &&
                                <>
                                    <div className="input-field3" >
                                        <label htmlFor="">Vehicle Type</label>
                                        {
                                            isInput === "HIRE" ?
                                                <input type="text" placeholder="Vehicle Type"
                                                    className="input"
                                                    value={formData.vehicleType}
                                                    onChange={(e) => setFormData({ ...formData, vehicleType: e.target.value })} />
                                                :
                                                <Select
                                                    options={getVehicle.map(vehicle => ({
                                                        value: vehicle.vehicle_model,   // adjust keys from your API
                                                        label: vehicle.vehicle_model,
                                                        vehicle_number: vehicle.vehicle_number,
                                                    }))}
                                                    value={
                                                        formData.vehicleType
                                                            ? { value: formData.vehicleType, label: getVehicle.find(c => c.vehicle_model === formData.vehicleType)?.vehicle_model || "" }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            vehicleType: selectedOption ? selectedOption.value : "",
                                                            vehicleNo: selectedOption ? selectedOption.vehicle_number : ""
                                                        })
                                                    }
                                                    placeholder="Vehicle Type"
                                                    isSearchable
                                                    classNamePrefix="blue-selectbooking"
                                                    className="blue-selectbooking"
                                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                                    styles={{
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }),
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                                    }}
                                                />
                                        }

                                    </div>
                                    <div className="input-field3" >
                                        <label htmlFor="">Vehicle Number</label>
                                        {

                                            <input type="text" placeholder="Vehicle Number"
                                                className="input"
                                                value={formData.vehicleNo}
                                                onChange={(e) => setFormData({ ...formData, vehicleNo: e.target.value })} />



                                        }

                                    </div>
                                </>}
                            {isChecked.Driver_Name &&
                                <>
                                    <div className="input-field3" >
                                        <label htmlFor="">Driver Name</label>
                                        <Select
                                            options={getDriver.map(driver => ({
                                                value: driver.Driver_Code,   // adjust keys from your API
                                                label: driver.Driver_Name,
                                                MobileNo: driver.MobileNo,
                                            }))}
                                            value={
                                                formData.driverName
                                                    ? { value: formData.driverName, label: getDriver.find(c => c.Driver_Code === formData.driverName)?.Driver_Name || "" }
                                                    : null
                                            }
                                            onChange={(selectedOption) =>
                                                setFormData({
                                                    ...formData,
                                                    driverName: selectedOption ? selectedOption.value : "",
                                                    driverMobile: selectedOption ? selectedOption.MobileNo : ""
                                                })

                                            }
                                            placeholder="Driver Name"
                                            isSearchable
                                            classNamePrefix="blue-selectbooking"
                                            className="blue-selectbooking"
                                            menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                            styles={{
                                                placeholder: (base) => ({
                                                    ...base,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                            }}
                                        />
                                    </div>
                                    <div className="input-field3" >
                                        <label htmlFor="">Driver Number</label>
                                        <input type="tel" placeholder="Driver Number" maxLength={10}
                                            className="input"
                                            value={formData.driverMobile} onChange={(e) => setFormData({ ...formData, driverMobile: e.target.value })} />
                                    </div>
                                </>}

                            {isChecked.Train_Name &&
                                <>
                                    <div className="input-field3">
                                        <label>Train Name</label>

                                        <Select
                                            className="blue-selectbooking"
                                            classNamePrefix="blue-selectbooking"
                                            options={allTrainOptions}
                                            value={
                                                formData.Train_Code
                                                    ? allTrainOptions.find(opt => opt.value === formData.Train_Code)
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    Train_Code: selectedOption.value,
                                                    TrainNo: selectedOption.trainNo
                                                }));
                                            }}
                                            placeholder="Select Train Name"
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{
                                                placeholder: (base) => ({
                                                    ...base,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                            }}
                                        />

                                    </div>
                                    <div className="input-field3" >
                                        <label htmlFor="">Train Number</label>
                                        <input type="tel" placeholder="Train Number" className="input"
                                            value={formData.TrainNo} onChange={(e) => setFormData({ ...formData, TrainNo: e.target.value })} />
                                    </div>
                                </>}

                            {isChecked.Flight_Name &&
                                <>
                                    <div className="input-field3" >
                                        <label>Flight Name</label>

                                        <Select
                                            className="blue-selectbooking"
                                            classNamePrefix="blue-selectbooking"
                                            options={allFlightOptions}
                                            value={
                                                formData.Flight_Code
                                                    ? allFlightOptions.find(opt => opt.value === formData.Flight_Code)
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    Flight_Code: selectedOption.value,
                                                    FlightNo: selectedOption.flightNo
                                                }));
                                            }}
                                            placeholder="Select Flight Name"
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{
                                                placeholder: (base) => ({
                                                    ...base,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                            }}
                                        />

                                    </div>
                                    <div className="input-field3" >
                                        <label htmlFor="">Flight Number</label>
                                        <input type="tel" placeholder="Flight Number"
                                            className="input"
                                            value={formData.FlightNo} onChange={(e) => setFormData({ ...formData, FlightNo: e.target.value })} />
                                    </div>
                                </>}


                            {isChecked.Vendor_Name && <div className="input-field3" >
                                <label htmlFor="">Vendor Name</label>
                                <Select
                                    options={getVendor.map(vendor => ({
                                        value: vendor.Vendor_Code,   // adjust keys from your API
                                        label: vendor.Vendor_Name
                                    }))}
                                    value={
                                        formData.vendorCode
                                            ? { value: formData.vendorCode, label: getVendor.find(c => c.Vendor_Code === formData.vendorCode)?.Vendor_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            vendorCode: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Vendor Name"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                />

                            </div>}

                            {isChecked.Vendor_Awb_No && <div className="input-field3" >
                                <label htmlFor="">Vendor Awb No</label>
                                <input type="text" placeholder="Vendor Awb No" maxLength={10}
                                    className="input"
                                    value={formData.vendorAwbNo} onChange={(e) => setFormData({ ...formData, vendorAwbNo: e.target.value })} />
                            </div>}

                            {isChecked.Remark && <div className="input-field3" >
                                <label htmlFor="">Remark</label>
                                <input type="text" placeholder="Remark" value={formData.remark}
                                    className="input"
                                    onChange={(e) => setFormData({ ...formData, remark: e.target.value })} />
                            </div>}

                            {isChecked.MasterAwbNo && <div className="input-field3" >
                                <label htmlFor="">Master Awb No</label>
                                <input type="text" placeholder="Master Awb No" maxLength={10}
                                    className="input"
                                    value={formData.MAwbNo} onChange={(e) => setFormData({ ...formData, MAwbNo: e.target.value })} />
                            </div>}

                            {isChecked.Dox_Spx && <div className="input-field3" >
                                <label htmlFor="">Dox / Spx </label>
                                <select
                                    value={formData.DoxSpx} onChange={(e) => setFormData({ ...formData, DoxSpx: e.target.value })} >
                                    <option value="">Select Dox/Spx</option>
                                    <option value="Dox">Dox</option>
                                    <option value="Box">Box</option>
                                </select>
                            </div>}

                            {isChecked.BagNo && <div className="input-field3" >
                                <label htmlFor="">Bag No</label>
                                <input type="text" placeholder="Bag No" maxLength={10}
                                    className="input"
                                    value={formData.bagNo} onChange={(e) => setFormData({ ...formData, bagNo: e.target.value })} />
                            </div>}


                            {isChecked.Manifest_Weight && <div className="input-field3" >
                                <label htmlFor="">Manifest Weight</label>
                                <input type="text" placeholder="Manifest Weight" value={formData.manifestWeight}
                                    className="input"
                                    onChange={(e) => setFormData({ ...formData, manifestWeight: e.target.value })} />
                            </div>}

                            <div className="input-field3">
                                <label>Docket No</label>
                                <div style={{ display: "flex", gap: "5px" }}>
                                    <input
                                        style={{ flex: 1 }}
                                        type="text"
                                        className="input"
                                        placeholder="Enter Docket No"
                                        autoFocus
                                        name=""
                                        value={formData.bookingWeight}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                bookingWeight: e.target.value
                                            })
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault(); // stop form submit
                                                handleFind();       // auto call after scan
                                            }
                                        }}
                                    />
                                    <button type="button" className="ok-btn" style={{ width: "40px" }} onClick={handleFind}>Find</button>
                                </div>

                            </div>

                            <div className="input-field2" >
                                <label htmlFor="" style={{ whiteSpace: "nowrap" }}>Bulk Manifest</label>
                                <button type="button" className="ok-btn" style={{ height: "35px", width: "100%", fontSize: "14px", lineHeight: "1" }}
                                    onClick={() => { setModalIsOpen(true) }}>Bulk Manifest</button>
                            </div>

                            





                            <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px"}}>

                                <button type="submit" className="ok-btn" style={{}}>Generate</button>
                                <button type="button" className="ok-btn" style={{ width: "50px" }} onClick={handleReset}>Reset</button>
                                <button type="button" className="ok-btn" onClick={() => { setModalIsOpen2(true) }}>Setup</button>
                            </div>

                        </div>
                    </form>
                    <div className="table-container" style={{ whiteSpace: "nowrap" }}>
                        <table className="table table-bordered table-sm">
                            <thead className="table-sm">
                                <tr>
                                    <th className="w-60">Sr.No</th>
                                    <th>Branch.Code</th>
                                    <th>Branch.Name</th>
                                    <th>Docket.No</th>
                                    <th>Date</th>
                                    <th>Client Name</th>
                                    <th>Receiver</th>
                                    <th>From City</th>
                                    <th>To City</th>
                                    <th>Qty</th>
                                    <th>Weight</th>
                                    <th>Invoice.No</th>
                                    <th>Invoice.Value</th>
                                    <th>E-Way.Bill.No</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    selectedManifestRows.map((manifest, index) => (
                                        <tr key={index}>
                                            <td className="w-60">{index + 1}</td>
                                            <td>{manifest.Branch_code}</td>
                                            <td>{manifest.Branch_Name}</td>
                                            <td>{manifest.DocketNo}</td>
                                            <td>{manifest.BookDate}</td>
                                            <td>{manifest.customerName}</td>
                                            <td>{manifest.consigneeName}</td>
                                            <td>{manifest.fromDest}</td>
                                            <td>{manifest.toDest}</td>
                                            <td>{manifest.pcs}</td>
                                            <td>{manifest.actualWt}</td>
                                            <td>{manifest.invoiceNo}</td>
                                            <td>{manifest.invoiceValue}</td>
                                            <td>{manifest.eWayBillNo}</td>
                                        </tr>

                                    ))}
                            </tbody>
                        </table>
                    </div>

                    <Modal
                        overlayClassName="custom-overlay"
                        isOpen={modalIsOpen}
                        className="custom-modal"
                        contentLabel="Modal"
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',

                                overflowY: 'auto',     // ✅ enable vertical scroll
                                overflowX: 'auto',   // optional (clean UI)
                                zIndex: "999999999",
                            },
                        }}
                    >
                        <div className="custom-modal-content">
                            <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                                <header style={{ width: "95%", textAlign: "center" }}>Pending Manifest Data</header>
                                <button className="ok-btn" style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                                    onClick={() => setModalIsOpen(false)}>
                                    <i className="bi bi-x-lg"></i>
                                </button>
                            </div>
                            <div className='container2' style={{ borderRadius: "0px", padding: "10px" }}>

                                <div className="addNew" style={{ whiteSpace: "nowrap" }}>


                                    <div className="search-input">
                                        <input
                                            className="add-input1"
                                            type="text"
                                            placeholder="search"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            style={{ marginLeft: "0%" }}
                                        />
                                        <button type="submit" title="search">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>


                                    <div className="custom-field">

                                        <div className="custom-date input-field">
                                            <label >From Date</label>
                                            <DatePicker
                                                portalId="root-portal"
                                                selected={fromDate}
                                                onChange={(date) => setFromDate(date)}
                                                dateFormat="dd/MM/yyyy"

                                            />
                                        </div>

                                        <div className="custom-date input-field" >
                                            <label >To Date</label>
                                            <DatePicker
                                                portalId="root-portal"
                                                selected={toDate}
                                                onChange={(date) => setToDate(date)}
                                                dateFormat="dd/MM/yyyy"

                                            />
                                        </div>

                                    </div>



                                    <div className="bottom-buttons">
                                        <button style={{ marginTop: "5px" }} className="ok-btn" onClick={handleDocketNoSelect}>Submit</button>
                                    </div>

                                </div>


                                <div className='table-container' style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                                        <thead className='table-sm'>
                                            <tr style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                                <th scope="col" className="w-60">
                                                    <input type="checkbox" checked={selectAll}
                                                        onChange={handleSelectAll} />
                                                </th>
                                                <th className="w-60"> Sr.No</th>
                                                <th>Branch.Code</th>
                                                <th>Branch.Name</th>
                                                <th>Docket.No</th>
                                                <th>Date</th>
                                                <th>Client Name</th>
                                                <th>Receiver</th>
                                                <th>From City</th>
                                                <th>To City</th>
                                                <th>Qty</th>
                                                <th>Weight</th>
                                                <th>Invoice.No</th>
                                                <th>Invoice.Value</th>
                                                <th>E-Way.Bill.No</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-body'>

                                            {
                                                getManifest.map((manifest, index) => (
                                                    <tr key={index}>
                                                        <td scope="col" className="w-60">
                                                            <input type="checkbox" checked={selectedRows.includes(index)}
                                                                onChange={() => handleRowSelect(index, manifest.DocketNo, getManifest.length)} />
                                                        </td>
                                                        <td className="w-60">{index + 1}</td>
                                                        <td>{manifest.Branch_code}</td>
                                                        <td>{manifest.Branch_Name}</td>
                                                        <td>{manifest.DocketNo}</td>
                                                        <td>{manifest.BookDate}</td>
                                                        <td>{manifest.customerName}</td>
                                                        <td>{manifest.consigneeName}</td>
                                                        <td>{manifest.fromDest}</td>
                                                        <td>{manifest.toDest}</td>
                                                        <td>{manifest.pcs}</td>
                                                        <td>{manifest.actualWt}</td>
                                                        <td>{manifest.invoiceNo}</td>
                                                        <td>{manifest.invoiceValue}</td>
                                                        <td>{manifest.eWayBillNo}</td>
                                                    </tr>

                                                ))}

                                        </tbody>
                                    </table>
                                </div>

                                <div className="row" style={{ whiteSpace: "nowrap" }}>
                                    <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                                        <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                            {'<'}
                                        </button>
                                        <span style={{ color: "#333", padding: "5px" }}>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                        <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            {'>'}
                                        </button>
                                    </div>

                                    <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                                        <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                                        <select
                                            id="rowsPerPage"
                                            value={rowsPerPage}
                                            onChange={(e) => {
                                                setRowsPerPage(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}

                                            style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={200}>200</option>
                                            <option value={500}>500</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen2}
                        className="custom-modal-custCharges" contentLabel="Modal"
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                whiteSpace: "nowrap",
                                height: "auto"
                            },
                        }}>

                        <div className="custom modal-content">
                            <div className="header-tittle"><header>Charges</header></div>

                            <div className='container2'>
                                <form onSubmit={handleUpdate}>
                                    <div className="fields2">

                                        {/* 🔘 All Select */}
                                        <div className="input-field1" style={{ display: "flex", flexDirection: "row" }}>
                                            <input type="checkbox"
                                                name="all"
                                                checked={isAllChecked}
                                                onChange={handleCheckChange}
                                                style={{ width: "12px", height: "12px", marginTop: "5px" }} />
                                            <label style={{ marginLeft: "10px", fontSize: "12px" }}>All Select</label>
                                        </div>

                                        {[
                                            "Vehicle_Detail", "Vehicle_Type", "Driver_Name", "Train_Name",
                                            "Flight_Name", "Vendor_Name", "Vendor_Awb_No", "Remark",
                                            "Manifest_Weight", "MasterAwbNo", "Dox_Spx", "BagNo"
                                        ].map((item, i) => (
                                            <div className="input-field1" style={{ display: "flex", flexDirection: "row" }} key={i}>
                                                <input type="checkbox"
                                                    name={item}
                                                    checked={isChecked[item] || false}
                                                    onChange={handleCheckChange}
                                                    style={{ width: "12px", height: "12px", marginTop: "5px" }} />
                                                <label style={{ marginLeft: "10px", fontSize: "12px" }}>{item}</label>
                                            </div>
                                        ))}

                                    </div>

                                    <div className='bottom-buttons'>
                                        <button className='ok-btn'>Submit</button>
                                        <button type="button" onClick={() => setModalIsOpen2(false)} className='ok-btn'>close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>



                </div >
            </div >
        </>
    );
};


export default CreateManifest;